import { useQuery } from '@hooks/reactQuery';

import { getDropdownAssetsAttached } from '@api/assignApprovalUnit';

import { IAssetSubtypeById, IAssetTypeSubtypeResponse } from '@interfaces/assets/asset';
import { IAttachedAssetDropdownOptions } from '@interfaces/organisation/dto/approvalUnitsDTO';

import { refetchOptions } from '@constants/common';
import { ATTACHED_TYPES_SUBTYPES } from '@constants/queryKeys';

export const useQueryDropdownAssetsAttached = () => {
	const {
		data: dropdownAssetsAttached,
		isLoading: isLoadingDropdownAssetsAttached,
		isFetching: isFetchingDropdownAssetsAttached,
	} = useQuery<IAssetTypeSubtypeResponse[], IAttachedAssetDropdownOptions>({
		queryKey: [ATTACHED_TYPES_SUBTYPES],
		queryFn: getDropdownAssetsAttached,
		select: (options: Array<IAssetTypeSubtypeResponse>) => {
			return options.reduce((acc: IAttachedAssetDropdownOptions, option) => {
				const type = {
					...option,
					value: option.type.id,
					label: option.type.assetTypeName,
				};

				const subType = option?.subTypes?.map((subType: IAssetSubtypeById) => ({
					...subType,
					value: subType.id,
					label: subType.assetSubTypeName,
				})) || [];

				return {
					types: [...acc.types, type],
					subTypes: {
						...acc.subTypes,
						[option.type.id]: subType,
					},
				};
			}, { types: [], subTypes: {} });
		},
		...refetchOptions,
	});

	return {
		dropdownAssetsAttached: dropdownAssetsAttached || { types: [], subTypes: {} },
		isLoadingDropdownAssetsAttached: isLoadingDropdownAssetsAttached || isFetchingDropdownAssetsAttached,
	};
};
